import {
  Box,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAxios } from "../../hooks";
import { colors } from "../css components/Style";

const fallbackCategoryColors = {
  PAYMENT: "#c09cdd",
  EMPLOYMENT: "#c62c6e",
  AFFLUENCE: "#4a77a0",
  TRAVEL: "#df2236",
  DEVICE: "#7b2cbf",
  FOOD: "#ffb703",
  LIFESTYLE: "#3a7d44",
  SPENDS: "#6c757d",
  VEHICLE: "#df2236",
  FINANCIAL_STRENGTH: colors.publicisBlue,
};

export default function ReadyMadeCohorts() {
  const axios = useAxios();
  const [cohorts, setCohorts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [category, setCaterogies] = useState({});
  const [gridSize, setGridSize] = useState({ rows: 0, cols: 0 });

  useEffect(() => {
    setLoading(true);
    axios({
      url: "/quick/segments",
      disableError: true,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        const segments = response.data.quickSegment || [];

        // dynamically determine max rows/cols from data
        const maxRow = Math.max(...segments.map((p) => p.row), 0);
        const maxCol = Math.max(...segments.map((p) => p.col), 0);

        setGridSize({ rows: maxRow, cols: maxCol });
        let colorCategory = {};
        response.data.quickSegment?.map((coh) => {
          if (!colorCategory[coh.category]) {
            colorCategory[coh.category] = coh.color;
          }
          return colorCategory;
        });
        setCaterogies(colorCategory);
        setCohorts(segments);
      }
      setLoading(false);
    });
  }, [axios]);

  return (
    <Box p={2}>
      <Grid container direction="column" spacing={1}>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={2}
          >
            <CircularProgress sx={{ color: colors.publicisBlue }} />
            <Typography variant="body2" sx={{ mt: 2 }}>
              Please wait while we load cohorts...
            </Typography>
          </Box>
        ) : (
          [...Array(gridSize.rows)].map((_, rowIdx) => (
            <Grid key={rowIdx} container item spacing={1}>
              {[...Array(gridSize.cols)].map((_, colIdx) => {
                const persona = cohorts.find(
                  (p) => p.row === rowIdx + 1 && p.col === colIdx + 1
                );

                return (
                  <Grid item key={colIdx}>
                    {persona ? (
                      <Tooltip
                        placement="top"
                        title={`${persona.label} • ${persona.size}`}
                        arrow
                      >
                        <Box
                          sx={{
                            cursor: "pointer",
                            width: 90,
                            height: 90,
                            border: `3px solid ${
                              persona.color ||
                              fallbackCategoryColors[persona.category] ||
                              "#ccc"
                            }`,
                            borderRadius: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            fontSize: 12,
                            p: 0.5,
                            bgcolor: persona.status ? "transparent" : "#f0f0f0",
                          }}
                        >
                          <strong>{persona.symbol}</strong>
                          <small>{persona.label}</small>
                        </Box>
                      </Tooltip>
                    ) : (
                      <Box sx={{ width: 90, height: 90 }} />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          ))
        )}
      </Grid>

      {/* Legend */}
      <Grid container spacing={2} mt={8}>
        {Object.entries(category).map(([key, color]) => (
          <Grid item key={key}>
            <Typography
              sx={{ color, display: "flex", margin: "0 6px" }}
              variant="body2"
            >
              <div
                style={{
                  borderRadius: "50%",
                  height: "10px",
                  width: "10px",
                  marginRight: "8px",
                  position: "relative",
                  top: "4px",
                  background: color,
                }}
              />{" "}
              {key.replace("_", " ")}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
